import { Component } from "@angular/core";
import { NgIf, NgClass } from "@angular/common";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-common-environment-banner",
  templateUrl: "./common-environment-banner.component.html",
  styleUrls: ["./common-environment-banner.component.scss"],
  imports: [NgIf, NgClass],
})
export class CommonEnvironmentBannerComponent {
  showBanner = environment.showEnvironmentBanner;
  environmentName = environment.environmentName;
  bannerColor = environment.environmentBannerColor;
}
